export default {
      id: "left-arrow-green-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#left-arrow-green-usage",
      toString: function () {
        return this.url;
      }
    }